/**
 * Cometa Taller · Acordeón Accesible (assets/src/acordeon.js)
 *
 * Cumple con accesibilidad WCAG 2.1:
 * - Botón con aria-expanded="false|true"
 * - Expande/colapsa panel de contenido sin dependencias externas.
 */

export function initAcordeon() {
  const triggers = document.querySelectorAll('.ct-acordeon-trigger');

  triggers.forEach((trigger) => {
    const contenido = trigger.nextElementSibling;
    if (contenido && !trigger.classList.contains('ct-acordeon--iniciado')) {
      trigger.classList.add('ct-acordeon--iniciado');
      // Ocultar por defecto excepto si ya está expandido
      if (trigger.getAttribute('aria-expanded') !== 'true') {
        contenido.style.display = 'none';
      }

      trigger.addEventListener('click', () => {
        const expandido = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', !expandido);
        contenido.style.display = expandido ? 'none' : 'block';
        
        const svg = trigger.querySelector('svg');
        if (svg) {
          svg.style.transform = expandido ? 'rotate(0deg)' : 'rotate(45deg)';
        }
      });
    }
  });
}
